export const SLIDER_CONSTS = {
    GET_MAIN_SLIDER: "GET_MAIN_SLIDER",
    GET_ABOUT_SLIDER: "GET_ABOUT_SLIDER",
};
